import { Reducer, Action } from "redux";
import { IPackageUpgradeState, KnownAction, RECEIVE_PACKAGE_DATA, SHOW_LOADER } from "./types";

export const reducer: Reducer<IPackageUpgradeState> = (state: IPackageUpgradeState | undefined, incomingAction: Action): IPackageUpgradeState => {
    if (state === undefined) {
        return {
            packageInformationData: {},
            isLoading: false,
        };
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case RECEIVE_PACKAGE_DATA:
            return {
                ...state,
                packageInformationData: action.packageInformationData,
            };
        case SHOW_LOADER:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        default:
            return state;
    }
};
